module.exports = __webpack_public_path__ + "img/downloads.77be8690.svg";